export const POOL_SCORES = [
  { label: "5 – 4", a: 5, b: 4, desc: "Slightly superior" },
  { label: "5 – 3", a: 5, b: 3, desc: "Clearly superior" },
  { label: "5 – 2", a: 5, b: 2, desc: "Very superior" },
  { label: "5 – 1", a: 5, b: 1, desc: "Gravely superior" },
  { label: "4 – 4", a: 4, b: 4, desc: "Tie" },
];

export const ELIM_SCORES = [
  { label: "3 – 2", a: 3, b: 2, desc: "Slightly superior" },
  { label: "3 – 1", a: 3, b: 1, desc: "Clearly superior" },
  { label: "3 – 3", a: 3, b: 3, desc: "Tie" },
];

export const PHASES = [
  { key: "pool", label: "5-Point", sub: "Pools" },
  { key: "elimination", label: "3-Point", sub: "Elimination" },
];

export const ROUND_OPTIONS = [1, 2, 3];

// A new discipline's public visibility, and the fallback used wherever
// disc.visibility (or an individual key on it) is missing — pools/bouts and pool
// scores are what spectators show up for during the pool phase, so those default
// on; everything else waits for the admin to opt in.
export const DEFAULT_DISCIPLINE_VISIBILITY = {
  pools: true, scores: true, standings: false, elimBracket: false, elimScores: false, judgeBreakdown: false,
};

// TOD ruleset 3.2 — additional criteria a judge weighs when effective hits are tied,
// to decide who was the round's superior fighter.
export const TIEBREAK_CRITERIA = [
  { title: "Tactical skill", desc: "Conducting the fight, use of space, handling the opponent while attacking, defending, and counter-attacking." },
  { title: "Bearing", desc: "General execution and fighting style, especially hitting without being hit." },
  { title: "Technical skill", desc: "Breadth of technical repertoire, timing, chaining actions in sequence, and their difficulty." },
  { title: "Effective strikes", desc: "Which fighter had more effective strikes (stronger hits, etc.)." },
  { title: "Forbidden strikes/actions", desc: "Negative weight for unfair fighting." },
];

export const getScoreOptions = (phase) =>
  phase === "pool" ? POOL_SCORES : ELIM_SCORES;
